import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Button } from '@fiverr-private/button';
import { ArrowLeftIcon } from '@fiverr-private/visuals';
import { translate } from '../../utils/translate';

interface Props {
    children?: React.ReactNode;
    goBack?: () => void;
}

export const OnboardingFooter = ({ children, goBack }: Props) => (
    <Container paddingTop={{ default: '16', lg: '0' }}>
        <Stack
            position={{ default: 'fixed', lg: 'static' }}
            backgroundColor="white"
            bottom={0}
            left={0}
            borderColor="grey_500"
            borderStyle="solid"
            borderTopWidth={{ default: 'sm', lg: 0 }}
            justifyContent="spaceBetween"
            paddingTop={{ default: '6', sm: '8' }}
            paddingBottom={{ default: '6', sm: '8', lg: '0' }}
            paddingX={{ default: '6', sm: '8', md: '10', lg: '0' }}
            width="100%"
        >
            {goBack && (
                <Container hidden={{ default: true, sm: false }}>
                    <Button type="button" size="md" variant="ghost" onClick={goBack}>
                        <ArrowLeftIcon size="sm" />
                        <Container as="span">{translate('general.back')}</Container>
                    </Button>
                </Container>
            )}

            {children && (
                <Stack alignItems={{ default: 'stretch', sm: 'flexEnd' }} direction="column" width="100%">
                    {children}
                </Stack>
            )}
        </Stack>
    </Container>
);
